import styled from 'styled-components'
import PropTypes from 'prop-types'

const MarginRight15 = styled.div`
  margin-right: 15px;
`

MarginRight15.propTypes = {
  textTruncate: PropTypes.bool
}

export default MarginRight15



// WEBPACK FOOTER //
// ./src/components/typography/margins/MarginRight15.js